import axios from "axios";
import { API_BASE_URL } from "./const/config";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  // Skip adding Authorization header for auth endpoints
  if (config.url?.includes("/auth/login/") || config.url?.includes("/auth/signup/")) {
    return config;
  }
  
  const token = localStorage.getItem(`${API_BASE_URL}_token`);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear the token from localStorage
      localStorage.removeItem(`${API_BASE_URL}_token`);
      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
